/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import axios from 'axios'
import Cookies from 'cookies-js'
import createHistory from 'history/createBrowserHistory'
import R from 'ramda'

const history = createHistory()

const getFieldErrorObject = (errors) => {
  let errorObject = {}
  R.map((error) => (
    errorObject[error.field_name] = error.errors[0].user_message
  ), errors)

  return errorObject
}

export const getCookie = (name) => {
  let cookieValue = null

  if (document.cookie && document.cookie !== '') {
    let cookies = document.cookie.split(';')

    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim()
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
        break
      }
    }
  }

  return cookieValue
}

// 403 : Forbidden Redirection
export const errorHandler = (error) => {
  if (error.response) {
    if (error.response.status === 403) {
      Cookies.set('isLogged', false)
      history.push({pathname: '/login/'})
      window.location.reload()
    }

    throw error
  }

  throw error
}

export const cleanEmptyObjects = (data) => {
  let cleaned = R.map((item) => {
    if (R.is(Object, item) &&
        item.length !== 0) {
      return cleanEmptyObjects(item)
    }

    return item
  }, data)

  let isEmpty = true
  R.map((item) => {
    if (!R.isNil(item) && !R.isEmpty(item) && typeof item !== 'boolean') {
      isEmpty = false
    }

    return item
  }, cleaned)

  if (isEmpty) {
    return null
  }

  return cleaned
}

export const removeMetaAndWorkflowObject = (data) => {
  if (R.is(Object, data)) {
    if (data.workflow_objects !== undefined) {
      delete data.workflow_objects
    }
    if (data.meta !== undefined) {
      delete data.meta
    }

    return R.map((item) => {
      if (R.is(Object, item)) {
        return removeMetaAndWorkflowObject(item)
      }

      return item
    }, data)
  }

  return data
}

const getRequest = (url, options={}) => {
  const csrftoken = getCookie('csrftoken')
  return axios({
    method: 'get',
    url: url,
    responseType: 'json',
    headers: {'X-CSRFToken': csrftoken},
    ...options
  })
  .catch(errorHandler)
}

const postRequest = (url, data) => {
  const csrftoken = getCookie('csrftoken')

  const cleanData = removeMetaAndWorkflowObject(cleanEmptyObjects(data))

  return axios({
    method: 'post',
    url: url,
    responseType: 'json',
    headers: {'X-CSRFToken': csrftoken},
    data: cleanData
  })
  .catch(errorHandler)
}

const deleteRequest = (url) => {
  const csrftoken = getCookie('csrftoken')

  return axios({
    method: 'delete',
    url: url,
    responseType: 'json',
    headers: {'X-CSRFToken': csrftoken}
  })
  .catch(errorHandler)
}

const Request = {
  getRequest,
  postRequest,
  deleteRequest,
  getFieldErrorObject,
  getCookie
}

export default Request



// WEBPACK FOOTER //
// ./src/generic/request/Request.js